var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.28 16.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: white;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.78,14.94s0,0,0,0c-1.03,1-2.74.97-3.74-.06-1-1.03-.97-2.74.06-3.74,0,0,0,0,0,0l3.75-3.63c1.05-1.01,2.72-.99,3.74.06.04.04.09.07.14.09l.87-.92s-.03-.07-.06-.09c-1.52-1.57-4.04-1.61-5.61-.09l-3.75,3.63s0,0,0,0c-1.54,1.5-1.58,4.06-.09,5.61.75.77,1.76,1.17,2.79,1.18,1.02.02,2.05-.35,2.82-1.09,0,0,0,0,0,0l2.09-2.03s.02-.03.03-.04l-.95-.9-2.09,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.18,1.18c-1.5-1.54-4.06-1.58-5.61-.09l-2.09,2.02.96.91,2.05-1.99s0,0,0,0c1.03-1,2.74-.97,3.74.06,1,1.03.97,2.74-.06,3.74l-3.75,3.63s0,0,0,0c-1.05,1.01-2.72.99-3.74-.06-.02-.02-.06-.04-.08-.06l-.89.94s.01.03.02.04c.76.78,1.77,1.19,2.78,1.2,1.01.02,2.04-.35,2.82-1.12,0,0,0,0,0,0l3.74-3.63s0,0,0,0c1.54-1.5,1.58-4.06.09-5.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/link-white.847b4857b0f58a95fbe14cecf8f0d63d.svg";
export { ForwardRef as ReactComponent };